import { format, parse } from 'date-fns';

import { createApp } from 'vue';

const app = createApp({});

app.config.globalProperties.$filters = {
  currency(value: number) {
    if (value) {
      return Number(value).toFixed(2);
    } else {
      return Number(0).toFixed(2);
    }
  },
  dateFormat(dateString: string, formatString:string) {
    if (dateString) {
      return format(parse(dateString, 'yyyy-MM-dd', new Date()), formatString);
    }
  },
  lowercase(value: string) {
    if (value) {
      return value.toLowerCase();
    }
  },
  uppercase(value: string) {
    if (value) {
      return value.toUpperCase();
    }
  }
};

app.mount('#app');